<template>
  <section
    id="cover"
    class="te-bg-jobs-image co-px-16 flex flex-col items-center justify-center bg-cover bg-center text-center text-co-gray-50"
    style="height: 520px"
  >
    <h1 class="te-title-mentor-recruits co-mb-12 font-bold leading-loose drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">
      <span class="te-title-mentor-jobs">メンター（講師）募集</span>
    </h1>
    <div
      class="alert mb-4 block rounded border-[#ffeeba] bg-[#fff3cd] text-center text-[#856404]"
      style="width: auto;"
    >
      <FontAwesomeIcon
        :icon="faTriangleExclamation"
        class="fa-fw inline pr-2"
      />
      現在募集を停止しています
    </div>
    <!-- <h2 class="co-display-10 mb-5 tracking-normal drop-shadow-[0_1px_2px_rgba(0,0,0,.3)] md:mb-12">
      テックアカデミーではメンターを随時募集しています
    </h2>
    <a
      href="#apply"
      class="co-btn-ghost-white rounded-full border-2 border-co-gray-50 text-co-gray-50"
      @click.prevent="scrollTo('mentor-entry-btn')"
    >
      エントリーする
    </a> -->
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTriangleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faTriangleExclamation,
    }
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-jobs-image {
  background-image: url('~/assets/images/Te/TeJob/Index/Cover/entry.jpg');
}

/* // jobs/ページカバータイトル */
.te-title-mentor-jobs {
  font-size: 1.625rem;
}

@media (min-width: 768px) {
  .te-title-mentor-jobs {
    font-size: 2.5rem;
  }
}

/* // メンター募集ページ用タイトル */
.te-title-mentor-recruits {
  font-size: 1.25rem;
}

@media (min-width: 768px) {
  .te-title-mentor-recruits {
    font-size: 2.25rem;
  }
}
</style>
